import axios from "axios"
import cloneDeep from "lodash.clonedeep"
import memoize from "lodash.memoize"

async function _get(uri, options) {
  return (await axios.get(uri, options)).data
}

const memoizedGet = memoize(_get)

async function get(uri, options) {
  const result = await memoizedGet(uri, options)
  return cloneDeep(result) // Clone to avoid cache mutation
}

function reset() {
  return memoizedGet.cache.clear()
}

function remove(uri) {
  return memoizedGet.cache.delete(uri)
}

async function runScript(scriptName) {
  return await get(`/api/script/runs/${scriptName}`)
}

export { get as getUriAndCacheResponse, remove as removeCachedUriResponse, reset as resetCache, runScript as runScriptAndCacheResponse }
